export const language: any = {
  title: 'ပစ္စည်းများ',
  select_all: 'အားလုံးကိုရွေးပါ',
  deselect_all: 'အားလုံးကိုမရွေးပါ',
  add: 'ပစ္စည်းများထည့်ပါ',
  add_title: 'ပစ္စည်းများထည့်ရန်နည်းလမ်းကိုရွေးပါ။',
  add_by_list: 'ပစ္စည်းများထည့်ပါ',
  add_total: '{number} ပစ္စည်းများထည့်ပါ',
  selecting: 'ပစ္စည်းများစုစုပေါင်း',
  filter_title: 'ရွေးချယ်မှုစီစဉ်ခြင်း',
  filter_newest: 'နောက်ဆုံးရ',
  filter_oldest: 'အဟောင်းဆုံး',
  filter_alphabet: 'အက္ခရာအစီအစဉ်',
  get_recipe: 'AI မှချက်ပြုတ်အကြံပြုချက်များရယူပါ',
  search_placeholder: 'သင့်အပေါ်ကိုရှာဖွေလိုသောစကားလုံးကိုထည့်ပါ။',
  nodata: 'မည်သည့်ပစ္စည်းမှမရှိပါ။',
  request: 'ပစ္စည်းများထည့်ပါ',
  recipe_title: 'အကြံပြုသောဟင်းလျာများ',
  option: {
    title: 'ရွေးချယ်မှုရွေးပါ',
    desc: 'ရွေးချယ်မှုကိုရွေးရန်မလိုအပ်ပါ။',
    complete: 'ပြီးစီးသည်',
    reset: 'ပြန်ညှိပါ။',
  },
  msg: {
    msg_7: "ရွေးချယ်ထားသောပစ္စည်းများကိုထည့်လိုပါသလား?",
    msg_8: `
      <p>ရွေးချယ်ထားသောပစ္စည်းများကိုထည့်လိုပါသလား?</p>
      <p class="text-[11px] font-normal">(<span class="text-primary">{name}</span> သည် ရှိပြီးသားအစားအသောက်ပစ္စည်းများတွင်ပါဝင်ထားသောကြောင့်အကျယ်အဝန်းထားပါသည်)</p>
    `,
    msg_9: "ရွေးချယ်ထားသောပစ္စည်းများကိုသင့်ဝယ်လက်ကားထဲထည့်လိုပါသလား?",
    msg_10: `
      <p>ရွေးချယ်ထားသောပစ္စည်းများကိုသင့်ဝယ်လက်ကားထဲထည့်လိုပါသလား?<br />
      <p class="text-[11px] font-normal">(<span class="text-primary">{name}</span> သည် ရှိပြီးသားအစားအသောက်ပစ္စည်းများတွင်ပါဝင်ထားသောကြောင့်အကျယ်အဝန်းထားပါသည်)</p>
    `,
    confirm: 'ထည့်ပါ',
    cancel: 'မလုပ်တော့ပါ',
    not_ingredient: 'ထည့်သွင်းထားသောအချက်အလက်သည် အစားအသောက်ပစ္စည်းမဟုတ်ပါ။<br />ကျေးဇူးပြု၍ ထပ်မံစစ်ဆေးပါ။',
    ai_failed: 'အစားအသောက်ပစ္စည်းထည့်သွင်းမှုအတွင်း အမှားတစ်ခုဖြစ်ပွားခဲ့ပါသည်။<br />ထပ်မံကြိုးစားပါ။',
    ingredient_exist_should_exclued: `(<span class="text-primary">{name}</span> သည် ရှိပြီးသားအစားအသောက်ပစ္စည်းများတွင်ပါဝင်ထားသောကြောင့်အကျယ်အဝန်းထားပါသည်)`
  },
  history: "ပုံသတင်းအချက်အလက်ခွဲခြမ်းစိတ်ဖြာမှတ်တမ်း",
  myIngredient: "အကြောင်းအရာများ",
  history_no_data: "မည်သည့်ခွဲခြမ်းမရှိပါ",
  history_take_photo: "ပုံရွေးသို့သွင်းပါ",
}
